import { render } from "./CategoryManageListPage.vue?vue&type=template&id=c82f6ae6&lang=true"
import script from "./CategoryManageListPage.vue?vue&type=script&lang=js"
export * from "./CategoryManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__